export default {
  "power-select-customs-search": "_power-select-customs-search_bda8my",
  "power-select-customs-search-input": "_power-select-customs-search-input_bda8my"
};